import { Auth } from '@nackle/bridge';
import { AUTH_ENDPOINT } from 'endpoints';

const auth = new Auth( {
    authority: AUTH_ENDPOINT,
    debug: false
} );

export default auth;

export function authRequestMiddleware( url, options = {} ) {
    if ( !auth || !auth.state || !auth.state.access_token ) {
        return;
    }

    options.headers = {
        ...( options.headers || {} ),
        'authorization': `Bearer ${ auth.state.access_token }`
    };
}

export function authRouteMiddleware( action, nextRoute, prevRoute ) {
    // we aren't signed in yet, so continue
    if ( !auth.state.access_token ) {
        return action.ok();
    }

    const nextCompanyId = nextRoute?.state?.params?.companyId;
    // if the next companyId is the same as the last companyId, continue
    if ( nextCompanyId === auth.state.company_id ) {
        return action.ok();
    }

    // switch to the new company
    auth.delegate( nextCompanyId ).then( () => {
        action.ok();
    } ).catch( error => {
        console.error( error );
    } );
}

/**
 * hasPermission checks if the users auth claims has the permission
 *
 * @param permission
 * @returns {boolean|*}
 */
export function hasPermission( permission ) {
    const [ app, key ] = permission.split( '.', 2 );
    
    const userPermissions = auth?.state?.claims?.permissions;
    if ( !userPermissions ) {
        return false;
    }
    const appPermissions = userPermissions[ app ];
    if ( !Array.isArray( appPermissions ) ) {
        return false;
    }
    return appPermissions.includes( key );
}

/**
 * permissions the list of permissions available 
 *
 */
export const permissions = {
    READ_MODULE_LIST: 'learning-record.read-module-list',
    EDIT_MODULE_LIST: 'learning-record.edit-module-list',
    DELETE_MODULE_LIST: 'learning-record.delete-module-list',
};
